<template>
    <div class="enters">
        <div
        class="item"
        v-for="(item, index) in guide"
        :key="index"
        :style="{backgroundImage: 'url(' + item.icon + ')'}"
        @click="goto(item.url)"
        >
            {{item.title}}
        </div>
    </div>
</template>

<script>
import iconGuide from '/static/images/img1.png';
import iconTel from '/static/images/img2.png';

export default {
    data() {
        return {
            guide: [
                {
                    title: '办事指南',
                    icon: iconTel,
                    url: '/guide'
                },
                {
                    title: '关于我们',
                    icon: iconGuide,
                    url: '/about'
                },
            ],
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .enters{
        .item{
            width: 100%;
            height: 122px;
            margin-bottom: 10px;
            font-size: 24px;
            font-weight: 500;
            line-height: 1em;
            padding: 22px 30px;
            text-align: center;
            color: #fff;
            font-weight: 600;
            letter-spacing: 1px;
            cursor: pointer;
            text-align: left;
            border-radius: 3px;

            img{
                vertical-align: middle;
                width: 26px;
                height: 26px;
            }

            // &:hover{
            //     transform: scale(1.1);
            //     transition: all .3s;
            // }
        }
    }
</style>